module.exports = __webpack_public_path__ + "static/img/wetan_logo.e2e8903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wetan_logo.png
// module id = 9dAS
// module chunks = 1